/** Shared industry options for Business Plan and Business Grant Proposal wizards. */

export const INDUSTRY_OTHER = 'Other (specify)';

export const INDUSTRIES = [
  'Agriculture & Agribusiness',
  'Construction & Real Estate',
  'Education & Training',
  'Energy & Power Solutions',
  'Financial Services & Fintech',
  'Food & Beverage',
  'Healthcare & Pharmaceuticals',
  'Hospitality & Tourism',
  'ICT & Software Development',
  'Logistics & Supply Chain',
  'Manufacturing & Production',
  'Media & Entertainment',
  'Professional Services',
  'Renewable Energy & Sustainability',
  'Retail & E-commerce',
  'Technology (General)',
  'Telecommunications',
  'Transportation & Haulage',
  INDUSTRY_OTHER,
];

/** Resolved industry string for backend / DOCX (never "Other (specify)"). */
export function resolveIndustry(sector, other) {
  if (sector === INDUSTRY_OTHER && (other || '').trim()) return other.trim();
  return sector || '';
}

/** Map legacy `industry` and draft fields → sector + other for the wizard UI. */
export function normalizeIndustryFields(source = {}) {
  const sector = source.industry_sector || '';
  const other = source.industry_other || '';
  if (sector && INDUSTRIES.includes(sector)) {
    return { industry_sector: sector, industry_other: other };
  }
  const legacy = source.industry || '';
  if (legacy && INDUSTRIES.includes(legacy)) {
    return { industry_sector: legacy, industry_other: '' };
  }
  if (legacy) {
    return { industry_sector: INDUSTRY_OTHER, industry_other: legacy };
  }
  return { industry_sector: sector, industry_other: other };
}
